<template>
  <div class="e-title">
    <div class="title-name">
      {{data.content}}
    </div>
  </div>
</template>
<script>
export default {
  name: 'e-title',
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../../assets/css/common';

.e-title {
  margin-bottom: 15px;

  & .title-name {
    position: relative;
    padding-left: 12px;
    @include lineFont(24, 600);
    color: $lightBlack;

    &::before {
      content: '';
      position: absolute;
      left: 0px; top: 1px;
      // transform: translateY(-50%);
      width: 4px; height: 22px;
      background: $blue;
      border-radius:2px;
    }
  }
}

@media screen and (max-width: 768px) {
  .e-title {
    padding: 0 20px;

    & .title-name {
      line-height: 1.2;

      &::before {
        top: 2px;
      }
    }
  }
}
</style>
